import { useState } from "react";
import { Button, Form, Modal, Table } from "react-bootstrap";
import Select from "react-dropdown-select";

import PaginationWithControls from "../PaginationWithControls";

interface ListUserProps {
  usersList: any;
  totalItemCount: number;
  pageIndex: number;
  pageSize: number;
  onChangePageIndex: (pageNumber: number) => void;
  onChangePageSize: (pageSize: number) => void;
  findOptions: any;
  resetFindOptions: () => void;
  handleFindUser: (findOptions: any) => void;
  stateListForDropdown: {
    stateName: string;
    stateId: string;
  }[];
}

const ListUsers: React.FC<ListUserProps> = ({
  usersList,
  totalItemCount,
  pageIndex,
  pageSize,
  onChangePageIndex,
  onChangePageSize,
  findOptions,
  resetFindOptions,
  handleFindUser,
  stateListForDropdown,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [searchOptions, setSearchOptions] = useState(findOptions);

  const handleModalClose = () => setShowModal(false);
  const handleModalOpen = () => setShowModal(true);

  const onChangeFieldValue = (value: object) => {
    setSearchOptions({ ...searchOptions, ...value });
  };

  const handelClearParameter = () => {
    setSearchOptions({
      stateId: 0,
      fullName: "",
      email: "",
      mobile: "",
      state: "",
    });
    resetFindOptions();
  };

  const onClickFind = (findOptions: any) => {
    handleFindUser(findOptions);
    handleModalClose();
  };

  return (
    <>
      <div className="float-end">
        <Button
          variant="primary"
          className="ml-1 mb-3"
          onClick={handleModalOpen}
        >
          Find Options
        </Button>
        <Modal show={showModal} onHide={handleModalClose}>
          <Modal.Header closeButton>
            <Modal.Title>Find Users</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Button
              className="mb-3"
              variant="secondary"
              onClick={() => handelClearParameter()}
            >
              Clear Parameters
            </Button>
            <Form>
              <Form.Group className="mb-3" controlId="find-full-name">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  value={searchOptions.fullName ? searchOptions.fullName : ""}
                  onChange={(e) =>
                    onChangeFieldValue({ fullName: e.target.value })
                  }
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="find-email">
                <Form.Label>email</Form.Label>
                <Form.Control
                  type="email"
                  value={searchOptions.email ? searchOptions.email : ""}
                  onChange={(e) =>
                    onChangeFieldValue({ email: e.target.value })
                  }
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="find-mobile">
                <Form.Label>Mobile</Form.Label>
                <Form.Control
                  type="text"
                  value={searchOptions.mobile ? searchOptions.mobile : ""}
                  onChange={(e) =>
                    onChangeFieldValue({ mobile: e.target.value })
                  }
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="findState">
                <Form.Label>State</Form.Label>
                <Select
                  options={stateListForDropdown}
                  labelField="stateName"
                  valueField="stateId"
                  searchable
                  searchBy={"stateName"}
                  onChange={(values) =>
                    onChangeFieldValue({ stateId: values[0]?.stateId })
                  }
                  values={[]}
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleModalClose}>
              Close
            </Button>
            <Button
              variant="primary"
              onClick={() => onClickFind(searchOptions)}
            >
              Find
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>User Id</th>
            <th>Name</th>
            <th>Mobile</th>
            <th>Email</th>
            <th>State</th>
          </tr>
        </thead>
        <tbody>
          {usersList.map((user: any, index: number) => (
            <tr key={user.userId}>
              <td>{user.userId}</td>
              <td>{user.fullName}</td>
              <td>{user.mobile}</td>
              <td>{user.email}</td>
              <td>{user.stateName}</td>
            </tr>
          ))}
        </tbody>
      </Table>
      {usersList.length > 0 ? (
        <>
          <PaginationWithControls
            pageIndex={pageIndex}
            pageSize={pageSize}
            listCount={totalItemCount}
            onChangePageIndex={onChangePageIndex}
            onChangePageSize={onChangePageSize}
          />
        </>
      ) : (
        <p className="text-center py-3">No results found</p>
      )}
    </>
  );
};

export default ListUsers;
